import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X, Phone, Mail, ArrowUpRight, MessageCircle, Instagram } from "lucide-react";
import { company } from "../data/siteData";
import { QuoteModal, openQuoteModal } from "./QuoteModal";

const navItems = [["/", "Início"], ["/sobre", "Sobre"], ["/servicos", "Serviços"], ["/contato", "Solicitar transfer"]];

export function Layout({ children }) {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  useEffect(() => {
    setOpen(false);
    window.scrollTo({ top: 0, behavior: "auto" });
  }, [location.pathname]);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 18);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div className="site-shell">
      <a className="skip-link" href="#conteudo" data-testid="skip-to-content-link">Pular para o conteúdo</a>
      <div className="topline" data-testid="corporate-message-bar">
        <span data-testid="corporate-message">{company.hours} • Condições especiais para empresas</span>
        <span className="topline__contact">
          <a href={`tel:+${company.phoneRaw}`} data-testid="top-phone-link"><Phone size={13} /> {company.phone}</a>
          <a href={`mailto:${company.email}`} data-testid="top-email-link"><Mail size={13} /> {company.email}</a>
        </span>
      </div>
      <header className={`main-header ${scrolled ? "main-header--scrolled" : ""}`} data-testid="main-header">
        <Link to="/" className="brand" aria-label="RC Mobility — página inicial" data-testid="header-logo-link">
          <img src="/images/brand/logo.webp" alt="Logotipo RC Mobility Executive Service" width="320" height="90" data-testid="header-logo-image" />
        </Link>
        <nav className={`main-nav ${open ? "main-nav--open" : ""}`} aria-label="Navegação principal" data-testid="main-navigation">
          {navItems.map(([to, label], index) => (
            to === "/contato"
              ? <button key={to} type="button" onClick={openQuoteModal} data-testid={`nav-link-${index}`}>{label}</button>
              : <NavLink key={to} to={to} data-testid={`nav-link-${index}`} className={({ isActive }) => isActive ? "active" : ""}>{label}</NavLink>
          ))}
        </nav>
        <button className="header-cta" type="button" onClick={openQuoteModal} data-testid="header-quote-button">Pedir agora <ArrowUpRight size={17} /></button>
        <button className="menu-button" onClick={() => setOpen(!open)} aria-label={open ? "Fechar menu" : "Abrir menu"} aria-expanded={open} data-testid="mobile-menu-button">
          {open ? <X /> : <Menu />}
        </button>
      </header>
      <main id="conteudo">{children}</main>
      <footer className="footer" data-testid="site-footer">
        <div className="footer__inner">
          <div className="footer__brand" data-testid="footer-brand-summary">
            <p className="footer__monogram">RC</p>
            <h2 data-testid="footer-company-name">RC Mobility</h2>
            <p data-testid="footer-description">Transporte executivo em Campinas e região com conforto, pontualidade e atendimento sob medida.</p>
          </div>
          <div data-testid="footer-navigation-group"><h3>Explore</h3>{navItems.map(([to, label], i) => to === "/contato" ? <button key={to} type="button" onClick={openQuoteModal} data-testid={`footer-nav-link-${i}`}>{label}</button> : <Link key={to} to={to} data-testid={`footer-nav-link-${i}`}>{label}</Link>)}</div>
          <div data-testid="footer-contact-group"><h3>Atendimento</h3><a href={`tel:+${company.phoneRaw}`} data-testid="footer-phone-link">{company.phone}</a><a href={`mailto:${company.email}`} data-testid="footer-email-link">{company.email}</a><span data-testid="footer-location">{company.location}</span><span data-testid="footer-hours">{company.hours}</span></div>
          <div data-testid="footer-cta-group"><h3>Próximo destino?</h3><p>Conte o trajeto. Cuidamos do restante.</p><button type="button" onClick={openQuoteModal} className="text-link" data-testid="footer-quote-link">Solicitar atendimento <ArrowUpRight size={16} /></button><a className="instagram-link" href={company.instagram} target="_blank" rel="noreferrer" data-testid="footer-instagram-link"><Instagram size={16} /> Instagram RC Mobility</a></div>
        </div>
        <div className="footer__bottom"><span data-testid="copyright-text">© {new Date().getFullYear()} RC Mobility. Todos os direitos reservados.</span><span data-testid="footer-service-note">Conforto • Pontualidade • Exclusividade</span></div>
      </footer>
      <div className="floating-socials" aria-label="Canais de atendimento">
        <a className="instagram-float" href={company.instagram} target="_blank" rel="noreferrer" aria-label="Ver Instagram da RC Mobility" data-testid="floating-instagram-link"><Instagram /></a>
        <a className="whatsapp-float" href={`https://wa.me/${company.phoneRaw}`} target="_blank" rel="noreferrer" aria-label="Falar com a RC Mobility pelo WhatsApp" data-testid="floating-whatsapp-link"><MessageCircle /></a>
      </div>
      <QuoteModal />
    </div>
  );
}
